import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking"); // checking | paid | failed
  const tries = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setState("failed");
      return;
    }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refreshUser();
          setState("paid");
          setTimeout(() => navigate("/wardrobe"), 1800);
          return;
        }
      } catch (e) {}
      tries.current += 1;
      if (tries.current > 10) {
        setState("failed");
        return;
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, navigate, refreshUser]);

  return (
    <div className="min-h-screen bg-bg0 flex items-center justify-center px-6">
      <div className="ep-card p-12 max-w-md w-full text-center" data-testid="payment-success-card">
        {state === "checking" && (
          <>
            <Loader2 size={40} className="animate-spin text-volt mx-auto" />
            <h1 className="font-display uppercase text-3xl font-bold tracking-tight mt-6">Confirming payment…</h1>
            <p className="text-epsub mt-3">Hang tight, activating your membership.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={44} className="text-volt mx-auto" />
            <h1 className="font-display uppercase text-3xl font-bold tracking-tight mt-6">You're in.</h1>
            <p className="text-epsub mt-3">Membership active. Taking you to your wardrobe…</p>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle size={44} className="text-epred mx-auto" />
            <h1 className="font-display uppercase text-3xl font-bold tracking-tight mt-6">Couldn't confirm.</h1>
            <p className="text-epsub mt-3">If you were charged, refresh in a moment.</p>
            <Link to="/subscribe" data-testid="back-to-subscribe" className="ep-btn inline-block mt-6 bg-volt text-black px-6 py-3 text-sm font-bold uppercase tracking-widest hover:bg-volt-hover">
              Back to plans
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
